<script setup>
import { Trash2Icon } from "lucide-vue-next";
import { useI18n } from "vue-i18n";
import PreviewInput from "./PreviewInput.vue";
import Badge from "@Components/Badge.vue";
import { computed } from "vue";

const category = defineModel("category");

const props = defineProps({
    localCategories: {
        type: Array,
        default: [],
    },
    depth: {
        type: Number,
        default: 0,
    },
});

defineEmits(["deleteCategory"]);

const { t: __ } = useI18n();

const localCategory = computed(() => {
    let id = category.value.id.replace("cat_", "");
    return props.localCategories.find((localCategory) => {
        return localCategory.term_id === parseInt(id);
    });
});

const depthClasses = computed(() => {
    switch (props.depth) {
        case 0:
            return "pl-0";
        case 1:
            return "pl-3";
        case 2:
            return "pl-6";
        case 3:
            return "pl-9";
        case 4:
            return "pl-12";
        default:
            return "pl-0";
    }
});
</script>
<template>
    <div :class="depthClasses">
        <div class="flex items-center gap-1.5">
            <Badge v-if="category.existing" class="flex-none text-xs">{{ __("Existante") }}</Badge>
            <Badge v-else class="flex-none text-xs">{{ __("Nouvelle") }}</Badge>
            <div class="grid flex-1 grid-cols-6 gap-1.5">
                <div class="col-span-full">
                    <PreviewInput
                        type="text"
                        :placeholder="__('Nom de la catégorie')"
                        :model-value="category.existing ? localCategory?.name : category.name"
                        @update:model-value="category.name = $event"
                        :readonly="category.existing" />
                </div>
            </div>
            <Trash2Icon
                @click="$emit('deleteCategory')"
                class="size-4 flex-none text-gray-600 cursor-pointer dark:text-gray-400 dark:hover:text-white hover:text-gray-900" />
        </div>
    </div>
</template>
